import React from "react";
import { Dialog } from "primereact/dialog";
import axios from "axios";
import "./ImportarExcelModal.css"
import AsyncSelect from "react-select/async";
import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";

class ImportarExcelModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            loading: false,
            property_of_interest: ""
        };

        this.fileInputRef = React.createRef();
    }

    triggerFileSelect = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    }

    handleImport = async () => {
        if (!this.state.file) {
            return alert("Insira um arquivo xlsx!");
        }
        if (!this.state.property_of_interest) {
            return alert("Selecione um empreendimento!");
        }

        this.setState({ loading: true });
        let formData = new FormData();
        formData.append("file", this.state.file);
        formData.append("property_of_interest", this.state.property_of_interest.value);

        try {
            const response = await axios.post("/geo-referenciamento/import", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data.status === "Success") {
                this.setState({ file: null });
                if (this.props.toast) {
                    this.props.toast();
                }
                if (this.props.reloadBuildings) {
                    this.props.reloadBuildings();
                }
                if (this.props.onHide) {
                    this.props.onHide();
                }
            }
        } catch (error) {
            console.error("Erro no upload", error);
            alert("Erro ao importar arquivo.");
        }
        finally {
            this.setState({ loading: false });
        }
    };

    renderFooter() {
        const { file } = this.state;

        return (
            <div className="importar-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>

                {!this.state.loading &&
                    <>
                        <button
                            type="button"
                            className="btn btn-default bold"
                            onClick={this.triggerFileSelect}
                            onMouseEnter={(e) => e.currentTarget.style.borderColor = '#71964a'}
                            onMouseLeave={(e) => e.currentTarget.style.borderColor = '#ced4da'}
                            style={{ minWidth: '100px' }}
                        >
                            <span>
                                {file ? file.name : "Selecionar"}
                            </span>
                        </button>

                        <button
                            type="button"
                            className="btn importar-btn-import bold"
                            onClick={this.handleImport}
                            disabled={this.state.loading}
                        >
                            IMPORTAR
                        </button>
                    </>
                }
                {this.state.loading && (
                    <img alt="carregando..." src="/img/loader.gif" style={{ height: '34px' }} />
                )}
            </div>
        );
    }

    render() {
        return (
            <Dialog
                header="Importar"
                visible={this.props.show}
                modal
                closable
                onHide={this.props.onHide}
                footer={this.renderFooter()}
                className="importar-dialog"
                style={{ marginTop: '20%' }}
            >
                <p className="importar-warning">
                    Fazer uma importação irá sobrescrever os dados anteriores.
                </p>

                <div className="importar-field">

                    <label>Empreendimento</label>
                    <AsyncSelect
                        styles={asyncSelectCustomStyles}
                        components={reactSelectIcons}
                        placeholder="Digite"
                        isMulti={false}
                        closeMenuOnSelect={true}
                        defaultOptions={this.props.buscaEmpreendimentossDefaultOptions}
                        loadOptions={this.props.searchBuildings}
                        onMenuClose={this.props.clearDefaultEmpreendimentos}
                        onChange={(value) => this.setState({ property_of_interest: value })}
                        loadingMessage={() => 'Carregando...'}
                        noOptionsMessage={() => "Digite para buscar..."}
                    />

                    <input
                        ref={this.fileInputRef}
                        id="file-upload-input"
                        type="file"
                        accept=".xlsx, .xls"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                                this.setState({ file: e.target.files[0] });
                            }
                        }}
                    />
                </div>
            </Dialog>
        );
    }
}

export default ImportarExcelModal;